export { default as OrderPayment } from './OrderPayment';
export * as Styled from './OrderPayment.styles';
export * from './OrderPayment.types';
